module.exports = __webpack_public_path__ + "img/medicine-cat.56cffa06.png";